import { idempotencyConfig } from "./idempotency";
export const createPayment = async (client, membershipId, req, options) => {
    const endpoint = membershipId
        ? `/payments/memberships/${membershipId}`
        : "/payments/memberships/null";
    const config = idempotencyConfig(options);
    const response = config
        ? await client.post(endpoint, req, config)
        : await client.post(endpoint, req);
    return response.data;
};
export const markPaid = async (client, paymentId, req) => {
    const response = await client.post(`/payments/${paymentId}/mark-paid`, req);
    return response.data;
};
export const markUnpaid = async (client, paymentId, req) => {
    const response = await client.post(`/payments/${paymentId}/mark-unpaid`, req);
    return response.data;
};
export const refundPayment = async (client, paymentId, req) => {
    const response = await client.post(`/payments/${paymentId}/refund`, req);
    return response.data;
};
export const voidPayment = async (client, paymentId, req) => {
    const response = await client.post(`/payments/${paymentId}/void`, req);
    return response.data;
};
export const getPayment = async (client, paymentId) => {
    const response = await client.get(`/payments/${paymentId}`);
    return response.data;
};
export const getRevenueReport = async (client, opts) => {
    const response = await client.get("/payments/clubs/report", { params: opts });
    return response.data;
};
export const listUnpaidPayments = async (client, params) => {
    const response = await client.get("/payments/clubs/unpaid", { params });
    return response.data;
};
export const getUserPaymentSummaries = async (client, opts) => {
    const response = await client.get("/payments/clubs/user-summaries", { params: opts });
    return response.data;
};
